module.exports = __webpack_public_path__ + "static/media/title.acaaa640.png";